import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { startEditNote } from '../../actions/favoriteEntities/notes';
import { NoteButton, INoteButtonProps } from '../../components/NoteButton';
import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { trackNoteButtonClick } from './trackings';

type TNoteButtonContainerDispatchProps = Pick<INoteButtonProps, 'onClick'>;
type TNoteButtonContainerOwnProps = Pick<INoteButtonProps, 'entityId'>;

function mapDispatchToProps(dispatch: TThunkDispatch, { entityId }: TNoteButtonContainerOwnProps) {
  return {
    onClick: bindActionCreators(() => startEditNote(entityId), dispatch),
  };
}

function mergeProps(
  state: IApplicationState,
  actions: TNoteButtonContainerDispatchProps,
  ownProps: TNoteButtonContainerOwnProps,
) {
  return {
    ...state,
    ...actions,
    ...ownProps,
    onClick: () => {
      actions.onClick();
      trackNoteButtonClick();
    },
  };
}

export const NoteButtonContainer = connect(null, mapDispatchToProps, mergeProps)(NoteButton);
